exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#fs5-get-paid-index[data-v-1ccfde83]{font-family:Lato}.header[data-v-1ccfde83]{color:#a5b9d5;line-height:1.2;font-weight:900;font-size:1.5em;margin-bottom:.7em;text-transform:uppercase}.disable-withdraw[data-v-1ccfde83]{font:inherit;font-size:1em;line-height:1.2;color:#fff;text-align:center;background:#ff4848;border-radius:4px;padding:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ccfde83","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v5/get_paid/user/index.vue
// module id = HuKw
// module chunks = 0